package ui.screens.section.hero.composable

import androidx.compose.animation.AnimatedVisibilityScope
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.BiasAlignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import org.jetbrains.compose.resources.painterResource
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.sun
import thewedding_cmp.composeapp.generated.resources.taj_mahal
import ui.celestialBodyImageName
import ui.screens.home.CelestialBody
import ui.screens.home.components.CelestialBodyConfig

@Composable
fun HeroImage(
    entered: Boolean,
    animatedVisibilityScope: AnimatedVisibilityScope,
) {
    val mainImageContainerHeight = 250.dp

    BoxWithConstraints(
        Modifier
            .padding(top = 20.dp)
            .height(mainImageContainerHeight)
            .fillMaxWidth()
    ) {
        CelestialBody(
            isVisible = entered,
            image = Res.drawable.sun,
            celestialBodyConfig = celestialBodyConfig,
            modifier = Modifier.zIndex(-0.15f)
        )

        Image(
            painter = painterResource(Res.drawable.taj_mahal),
            contentDescription = null,
            modifier = Modifier
//                .sharedBounds(
//                    rememberSharedContentState(key = "image-${TajMahal.name}"),
//                    animatedVisibilityScope
//                )
                .align(mainImageAlignment)
                .requiredHeight(mainImageContainerHeight)
                .zIndex(mainImageZIndex),
            contentScale = ContentScale.FillHeight,
            alignment = Alignment.BottomCenter,
        )
    }
}

private val celestialBodyConfig: CelestialBodyConfig
    get() = CelestialBodyConfig(
        name = celestialBodyImageName,
        alignment = BiasAlignment(.25f, -1.2f),
        height = .3f,
        hiddenStateYOffset = -.5f,
    )

private val mainImageZIndex
    get() = -0.1f

private val mainImageAlignment
    get() = Alignment.TopCenter
